import { getCmsPrivacyPolicyActon } from "../../../Actions/LogicActions/PrivacyPolicy/GetCmsPrivacyPolicyAction";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { privacyPolicyTree } from "../../../Orchestrator/ConstantTree";

class PrivacyPolicyInitStep extends StepFlow {
    get stepName() { return "PrivacyPolicyInit_Step"; }

    async onEventSetup(): Promise<void> {
        this.registerEventSubscription(
            _eventBus.on<void, void>({
                eventName: privacyPolicyTree.Content.Get,
                handler: async () => {
                    await getCmsPrivacyPolicyActon.execute()
                },
            })
        );
    }

    async onExecute(): Promise<void> {
        console.log("PrivacyPolicy Init Step Execute...")

        // Execute the action to fetch CMS Privacy Policy
        _eventBus.emit({
            eventName: privacyPolicyTree.Content.Get,
        });
    }
}

export const PrivacyPolicyInitStepDeclaration = new StepDefinition({
    stepName: "PrivacyPolicyInit_Step",
    stepClass: PrivacyPolicyInitStep
});